/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-27 11:30:29
 * @LastEditors: Pluto 66291979@qq.com
 * @LastEditTime: 2024-06-13 11:03:38
 * @FilePath: \lobby\src\common\valiadate.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
// function validateEmail(email) {
//     // 邮箱正则表达式
//     var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     var emailRegex = !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
//     // 使用正则表达式进行验证
//     return emailRegex.test(email);
//   }

// 巴西账号校验 BRA
//· 巴西手机号位数和号段规则
//1.手机号可以是10位，也可以是11位；
//2.前两位可输入内容：11~99；
//3.第三位和以后不会进行限制；
// ok, err := regexp.MatchString("^([11-99]{2})(\\d{8,9})$", req.Username)

// 肯尼亚账号校验 KE
//· 肯尼亚手机号位数和号段规则
//1.手机号为10位；
//2.前两位可输入内容：07：Safaricom、06：Airtel、01：Telkom、05：Equitel、02：Faiba；
//3.第三位和以后不会进行限制；
// ok, err := regexp.MatchString("^(07|06|01|05|02)(\\d{8})$", req.Username)
import { i18n } from '@/locales/index.js'

function validateUsername(username) {
  console.log(`validateUsername: ${username}`)
  const pattern = '^(\\d{9,10})$'
  const regex = new RegExp(pattern)
  if (regex.test(username)) {
    return ''
  }
  return i18n.global.t('register.username-error')
}

// CheckPasswordRules 校验密码规则
// 1.密码位数为6~24位，如果超过24位无法继续输入；
// 2.密码区域可输入内容为：数字、字母、英文符号；
// 3.密码不可以输入：“空格”；
// ok, _ := regexp.MatchString("^[A-Za-z\\d!@#$%^&*()-_]{6,24}$", password)
function validatePassword(password) {
  console.log(`validatePassword: ${password}`)
  const pattern = '^[A-Za-z\\d!@#$%^&*()-_]{6,24}$'
  const regex = new RegExp(pattern)
  if (regex.test(password)) {
    return ''
  }
  return i18n.global.t('register.password-error')
}

export { validateUsername, validatePassword }
